// /// <reference types="@angular/localize" />

// import { bootstrapApplication } from '@angular/platform-browser';
// import { appConfig } from './app/app.config';
// import { AppComponent } from './app/app.component';
// import { enableProdMode } from '@angular/core';
// import { environment } from './environments/environment';

// if (environment.production) {
//   enableProdMode();

//   const noop = () => { };

//   [
//     'log',
//     'warn',
//     'info',
//     'debug',
//     'table',
//     'error',
//     'trace',
//     'dir',
//     'group',
//     'groupCollapsed',
//     'groupEnd',
//   ].forEach((method) => {
//     (window.console as any)[method] = noop;
//   });
// }

// bootstrapApplication(AppComponent, appConfig)
//   .then((appRef) => {
//     const isLoggedIn = localStorage.getItem('loggedIn');

//     if (isLoggedIn) {
//       document.getElementById('startup-loader')?.remove();
//       return;
//     }

//     // appRef.isStable.subscribe((stable) => {
//     //   if (stable) {
//     //     const loader = document.getElementById('startup-loader');
//     //     if (loader) {
//     //       loader.remove();
//     //     }
//     //   }
//     // });
//     appRef.isStable.subscribe((stable) => {
//       if (stable) {
//         const loader = document.getElementById('startup-loader');
//         if (loader) {
//           loader.remove();
//         }
//       }
//     });
//   })
//   .catch((err) => console.error(err));

/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import localeAr_SA from '@angular/common/locales/ar-SA';
import localeEn from '@angular/common/locales/en';

registerLocaleData(localeAr);
registerLocaleData(localeAr_SA);
registerLocaleData(localeEn);
if (environment.production) {
  enableProdMode();

  const noop = () => { };

  [
    'log',
    'warn',
    'info',
    'debug',
    'table',
    'error',
    'trace',
    'dir',
    'group',
    'groupCollapsed',
    'groupEnd',
  ].forEach((method) => {
    (window.console as any)[method] = noop;
  });
}

// Start timer
const appStartTime = performance.now();

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    if (typeof (window as any).hideSplashScreen === 'function') {
      (window as any).hideSplashScreen();
    } else {
      const loader = document.getElementById('startup-loader');
      if (loader) {
        loader.remove();
      }
    }

    const totalTime = performance.now() - appStartTime;

    // Only keep this in development
    if (!environment.production) {
      console.log(
        `🚀 Startup loader hidden after ${totalTime.toFixed(2)} ms`
      );
    }
  })
  .catch((err) => {
    if (typeof (window as any).hideSplashScreen === 'function') {
      (window as any).hideSplashScreen();
    }
    console.error(err);
  });
